import {Component, OnInit, Input} from '@angular/core'
import {AngularFirestore} from 'angularfire2/firestore'
import {AngularFireAuth} from 'angularfire2/auth'
import {environment} from 'environments/environment'
import * as firebase from 'firebase/app'
import * as SparkMD5 from 'spark-md5'
import {LoaderService} from 'app/ui-shared/loader/loader.service'
import {UploadService} from './upload.service'

const CREATIVECOLLECTION = 'creatives'
@Component({
  selector: 'app-project-upload',
  templateUrl: './project-upload.component.html',
  styleUrls: ['./project-upload.component.scss'],
  providers: [UploadService],
})
export class ProjectUploadComponent implements OnInit {
  @Input() project
  show: boolean = false
  uploading: boolean = false

  constructor(private firestore: AngularFirestore, private auth: AngularFireAuth, public loader: LoaderService, public uploadService: UploadService) {}

  ngOnInit() {
    let lastTarget = null
    window.addEventListener('dragenter', e => {
      lastTarget = e.target
      this.show = true
    })
    window.addEventListener('dragleave', e => {
      if (e.target === lastTarget) this.show = false
    })
  }

  onDrop(event, options) {
    event.preventDefault()
    this.show = false
    this.uploadService.upload(event.dataTransfer.items, this.project, options)
  }
}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/project/project-upload/project-upload.component.ts